module.exports = __webpack_public_path__ + "static/media/moderna_laperlaintegrl.174f3cc6.png";